// SyncFusionDateTimePicker.jsx
import {
  DatePickerComponent,
  Inject,
  MaskedDateTime,
} from "@syncfusion/ej2-react-calendars";

const SyncFusionDatePicker = ({
  id,
  value,
  onChange,
  placeholder,
  min,
  max,
  width = "100%",
  step = 10,
  localUnderMaintenace,
}) => {
  return (
    <DatePickerComponent
      id={id}
      value={value}
      change={(e) => {
        if (e.value instanceof Date) {
          onChange(e.value);
        } else {
          onChange(null); // fallback
        }
      }}
      enableMask
      format="dd/MM/yyyy"
      locale="pt"
      placeholder={placeholder}
      min={min}
      max={max}
      width={width}
      strictMode={true}
      disabled={localUnderMaintenace == "S"}
    >
      <Inject services={[MaskedDateTime]}></Inject>
    </DatePickerComponent>
  );
};

export default SyncFusionDatePicker;
